module.exports = __webpack_public_path__ + "static/media/DAI-AVAX.af8ad5a7.png";